<template>
  <div class="v-stack h-stretch gap-3">
    <div class="h-stack h-space-between">
      <a class="heading-title-2">Balance</a>
      <button class="add" @click="$router.push('/finance/expenses/add/gear')">
        Add Expense
      </button>
    </div>
    <div class="card light mn">
      <div class="content h-stretch">
        <div class="v-stack h-stretch gap-3" v-if="data">
          <div class="v-stack h-stretch v-start gap-3 card py-5">
            <div class="pane-horizontal gap-3">
              <div class="text-right">Income:</div>
              <div class="text-left">
                {{ format.currency(data.totalIncome) }} kč
              </div>
            </div>
            <div class="pane-horizontal gap-3">
              <div class="text-right">Expenses:</div>
              <div class="text-left">
                {{ format.currency(data.totalCost) }} kč
              </div>
            </div>
            <div class="separator"></div>
            <div class="pane-horizontal gap-3" style="font-weight: bold">
              <div class="text-right">Balance:</div>
              <div class="text-left">
                {{ format.currency(data.balance) }} kč
              </div>
            </div>
          </div>
        </div>
        <div v-else><span class="loader"></span></div>
      </div>
    </div>
    <a class="heading-title-2">Expenses</a>
    <div
      class="card light link mn"
      @click="$router.push('/lifefinance/expenses')"
    >
      <div class="content h-stretch">
        <div class="v-stack h-stretch gap-3" v-if="data">
          <div class="pane-horizontal gap-3">
            <div class="v-stack h-stretch v-start gap-3 card py-5">
              <a>Additional Expenses</a>
              <div class="pane-horizontal gap-3">
                <div class="text-right">One Time Expenses:</div>
                <div class="text-left">
                  {{ format.currency(data.oneTimeExpenseCost) }} kč
                </div>
              </div>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Recurring Expenses:</div>
                <div class="text-left">
                  {{ format.currency(data.recurringExpenseCost) }} kč
                </div>
              </div>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Gear:</div>
                <div class="text-left">
                  {{ format.currency(data.totalGearCost) }} kč
                </div>
              </div>
            </div>
            <div class="v-stack h-stretch v-start gap-3 card py-5">
              <a>Workforce</a>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Crew:</div>
                <div class="text-left">
                  {{ format.currency(data.crewCost) }} kč
                </div>
              </div>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Freelancers:</div>
                <div class="text-left">Not yet implemented</div>
              </div>
            </div>
          </div>
          <div class="v-stack h-stretch v-start gap-3 card py-5">
            <a>Sum</a>
            <div class="pane-horizontal gap-3">
              <div class="text-right">Expenses:</div>
              <div class="text-left">
                {{ format.currency(data.expensesCost) }} kč
              </div>
            </div>
            <div class="pane-horizontal gap-3">
              <div class="text-right">Workforce:</div>
              <div class="text-left">
                {{ format.currency(data.totalWorkForceCost) }} kč
              </div>
            </div>
            <div class="separator"></div>
            <div class="pane-horizontal gap-3" style="font-weight: bold">
              <div class="text-right">Total:</div>
              <div class="text-left">
                {{ format.currency(data.totalCost) }} kč
              </div>
            </div>
          </div>
        </div>
        <div v-else><span class="loader"></span></div>
      </div>
    </div>
    <a class="heading-title-2">Income</a>
    <div
      class="card light link mn"
      @click="$router.push('/lifefinance/income')"
    >
      <div class="content h-stretch">
        <div class="v-stack h-stretch gap-3" v-if="data">
          <div class="v-stack h-stretch v-start gap-3 card py-5">
            <a>Sum</a>
            <div class="pane-horizontal gap-3">
              <div class="text-right">Projects:</div>
              <div class="text-left">
                {{ format.currency(data.projectIncome) }} kč
              </div>
            </div>
            <div class="separator"></div>
            <div class="pane-horizontal gap-3" style="font-weight: bold">
              <div class="text-right">Total:</div>
              <div class="text-left">
                {{ format.currency(data.totalIncome) }} kč
              </div>
            </div>
          </div>
        </div>
        <div v-else><span class="loader"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/utils.js";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      format: utils.format,
      data: null,
    };
  },
  computed: {
    balance() {
      return this.totalIncome - this.totalCost;
    },
  },
  methods: {
    ...mapActions(["getOverview"]),
    refresh() {
      this.data = null;
      this.getOverview({
        period: this.period,
        year: this.year,
        month: this.month,
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then((data) => {
          this.data = data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.refresh();
  },
  props: {
    period: {
      type: String,
      default: () => "",
    },
    year: {
      type: String,
      default: () => "",
    },
    month: {
      type: Number,
      default: () => "",
    },
    startDate: {
      type: String,
      default: () => "",
    },
    endDate: {
      type: String,
      default: () => "",
    },
  },
  watch: {
    period() {
      this.refresh();
    },
    year() {
      this.refresh();
    },
    month() {
      this.refresh();
    },
    startDate() {
      this.refresh();
    },
    endDate() {
      this.refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.link:hover {
  cursor: pointer;
  background-color: lightgray;
}
</style>
